<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间" prop="nickname">
                <a-range-picker style="width: 100%" v-model="dateRange" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" allow-clear/>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="类型" prop="nickname"  >
                <a-select  v-model="queryParam.type" placeholder="类型" clearable>
          <a-select-option :value="1">收入</a-select-option>
          <a-select-option :value="2">支出</a-select-option>
        </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <!-- <div class="table-operations">
        
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div> -->
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{y:450}"
        :columns="columns"
        :data-source="list"
      
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
       {{(current-1)*size+index+1}} 
      </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['user:voucher:edit']" />-->
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:voucher:edit']">
            <a-icon type="edit" />赠送
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['user:voucher:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['user:voucher:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageVoucher,listVoucher, delVoucher } from '@/api/user/voucher'
import {listScoreRecord,getBalanceRecord} from '@/api/user/scoreRecord'

import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'rechargeNum',
  components: {
    CreateForm
  },
  props:["type"],
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      dateRange: [],
      queryParam: {
        userId: null,
        createBeginTime:"",
        createEndTime:"",
        direction:"",
        type:null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,                    
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
         },
        // {
        //   title: '编号',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作前余额',
          dataIndex: 'beforeBalance',
          ellipsis: true,
          align: 'center'
        },
     
    
        {
          title: '变动余额',
          dataIndex: 'balance',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作后余额',
          dataIndex: 'afterBalance',
          ellipsis: true,
          align: 'center',
       
        },
        {
          title: '方向',
          dataIndex: 'direction',
          ellipsis: true,
          align: 'center',
             customRender:function (e) {
            if(e === 1){
              return "收入";
            } else {
              return "支出";
            }
          }
        },
        {
          title: '是否充值成功',
          dataIndex: 'isRecharge',
          scopedSlots: { customRender: 'isRecharge' },
          ellipsis: true,
          align: 'center',
          customRender:function (e) {
            if(e === 0){
              return "否";
            } else {
              return "是";
            }
          }
        },
        {
          title: '时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '总金额',
        //   dataIndex: 'totalBalance',
        //   scopedSlots: { customRender: 'totalBalance' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '类型',
        //   dataIndex: 'type',
        //   scopedSlots: { customRender: 'type' },
        //   ellipsis: true,
        //   align: 'center',
        //   customRender:function (e) {
        //     if(e === 1){
        //       return "充值";
        //     } 
        //     else  if(e === 2){
        //       return "支付";
        //     } 
        //     else  if(e === 3){
        //       return "退款";
        //     } 
        //     else  if(e === 4){
        //       return "提现";
        //     } 
        //     else if(e === 7) {
        //       return "冻结";
        //     }
        //   }
        // },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   width: '18%',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ]
    }
  },
  filters: {
  },
  activated () {
    // this.queryParam.userId = this.$route.query.userId
    if(this.type!='tk'){
        this.getList()
      }
   
  },
  computed: {
  },
  watch: {

  },
  methods: {
    // 这边是子组件
    goList(record,type){
    this.$nextTick(()=>{
      this.queryParam.userId = record.id
      this.queryParam.type = type
      console.log("22")
      this.list = []
      this.total = 0
      this.current = 0
      this.size = 0
      this.getList()
      })
      
    },
    /** 查询用户现金券信息列表 */
    getList () {
      this.loading = true
      if(this.dateRange !== null && this.dateRange !== '' && this.dateRange.length === 2) {
        this.queryParam.createBeginTime = this.dateRange[0] +" 00:00:00"
        this.queryParam.createEndTime = this.dateRange[1]+" 23:59:59"
      }else {
        this.queryParam.createBeginTime = null
        this.queryParam.createEndTime = null
      }
      this.list = []
      this.total= 0
      this.current= 0
      this.size= 0
 
      getBalanceRecord(this.queryParam).then(response => {
        this.loading = false
        this.total = response.data.total
        this.list = response.data.records
        if(this.list.length>0){
          this.list.forEach((item,i)=>{
            item.index = i+1
          })

        }
       
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        nickname: undefined,
        userId: undefined,
        totalCoupon: undefined,
        couponBalance: undefined,
        createBeginTime:"",
        createEndTime:"",
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delVoucher(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/voucher/export', {
            ...that.queryParam
          }, `用户现金券信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
